/*
  Fellheimat - Countdown fuer die Ankuendigungsleiste
  ---------------------------------------------------------------------------
  Gehoert zu snippets/fh-countdown.liquid. Liegt bewusst als eigene Datei vor
  und nicht als {% javascript %} im Baustein: die Ankuendigungsleiste steckt in
  der Kopfzeilen-Gruppe und rendert damit auf JEDER Seite, teils zweimal
  (ein Countdown je Ankuendigung). Als Asset laedt der Browser die Datei genau
  einmal und legt sie in den Cache.

  RECHNUNG
  ---------------------------------------------------------------------------
  Der Zaehler haengt an zwei festen Zahlen aus dem Liquid:

    data-anchor    Startpunkt als Unix-Sekunde (UTC, also zeitzonenfrei)
    data-duration  Laenge eines Durchlaufs in Sekunden

  Rest = Dauer - ((jetzt - Startpunkt) modulo Dauer)

  Daraus folgen die drei geforderten Eigenschaften von selbst:

  - Er laeuft weiter, waehrend niemand den Shop offen hat. Es wird nichts
    mitgezaehlt und nichts gespeichert, der Wert wird bei jedem Tick neu aus
    der Uhrzeit ausgerechnet. Wer die Seite schliesst und eine Stunde spaeter
    zurueckkommt, sieht eine Stunde weniger.
  - Er beginnt nach Ablauf von selbst wieder beim vollen Wert - das erledigt
    das Modulo, ohne Sonderfall im Code.
  - Alle Besucher sehen denselben Stand, denn der Startpunkt ist absolut und
    nicht pro Besucher gesetzt. Kein localStorage, kein Cookie.

  Basis ist Date.now() des Geraets, nicht die Serverzeit. Grund: Der Startpunkt
  ist bereits absolut, die Geraeteuhr ist heute praktisch immer synchronisiert -
  und eine im Liquid eingebaute Serverzeit waere in einer zwischengespeicherten
  Seite veraltet.

  Welche Einheiten angezeigt werden, entscheidet das Markup: das Skript sucht
  die vorhandenen [data-u]-Felder. Fehlt "d", landen die Tage in den Stunden,
  fehlt zusaetzlich "h", landen sie in den Minuten. Das Liquid rechnet identisch,
  damit die erste Darstellung ohne JavaScript schon stimmt.
*/

(() => {
  if (customElements.get('fh-countdown')) return;

  const pad2 = (value) => (value < 10 ? '0' + value : String(value));

  class FhCountdown extends HTMLElement {
    connectedCallback() {
      const duration = parseInt(this.dataset.duration, 10);
      const anchor = parseInt(this.dataset.anchor, 10);

      this.duration = Number.isFinite(duration) && duration > 0 ? duration : 86400;
      this.anchor = Number.isFinite(anchor) ? anchor : 0;
      this.pad = this.dataset.pad !== 'false';

      this.fields = {};
      this.querySelectorAll('[data-u]').forEach((field) => {
        this.fields[field.dataset.u] = field.querySelector('.fh-cd__n') || field;
      });

      // Zurueck aus einem schlafenden Tab oder aus dem Zurueck-Cache: sofort neu
      // rechnen, statt bis zu eine Sekunde auf einen falschen Wert zu schauen.
      this.wake = () => {
        if (!document.hidden) this.tick();
      };
      document.addEventListener('visibilitychange', this.wake);
      window.addEventListener('pageshow', this.wake);

      this.tick();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.wake);
      window.removeEventListener('pageshow', this.wake);
    }

    /* Verbleibende Sekunden im laufenden Durchlauf, als Kommazahl in (0, Dauer]. */
    remaining() {
      let into = (Date.now() / 1000 - this.anchor) % this.duration;
      if (into < 0) into += this.duration; // Startpunkt liegt in der Zukunft
      return this.duration - into;
    }

    tick() {
      clearTimeout(this.timer);

      const rest = this.remaining();
      this.paint(Math.floor(rest));

      // Auf die naechste volle Sekunde legen statt stur alle 1000 ms zu zaehlen.
      // So bleibt die Anzeige an der Uhr und driftet ueber Stunden nicht weg.
      const toNextSecond = (rest - Math.floor(rest)) * 1000;
      this.timer = setTimeout(() => this.tick(), Math.max(80, toNextSecond + 25));
    }

    paint(total) {
      const fields = this.fields;
      const has = (unit) => Object.prototype.hasOwnProperty.call(fields, unit);

      let left = total;
      let days = 0;
      let hours = 0;
      let minutes = 0;

      if (has('d')) {
        days = Math.floor(left / 86400);
        left -= days * 86400;
      }
      if (has('h')) {
        hours = Math.floor(left / 3600);
        left -= hours * 3600;
      }
      if (has('m')) {
        minutes = Math.floor(left / 60);
        left -= minutes * 60;
      }

      this.put('d', days, false);
      this.put('h', hours, true);
      this.put('m', minutes, true);
      this.put('s', left, true);
    }

    /* Tage bleiben ohne fuehrende Null - "01 Tage" liest sich falsch. */
    put(unit, value, mayPad) {
      const field = this.fields[unit];
      if (!field) return;

      const text = mayPad && this.pad ? pad2(value) : String(value);
      if (field.textContent !== text) field.textContent = text;
    }
  }

  customElements.define('fh-countdown', FhCountdown);
})();
